/// <amd-module name="SuiteCommerce.InventoryDisplay.Website.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.InventoryDisplay.Website.Model", ["require", "exports", "Backbone", "SuiteCommerce.InventoryDisplay.Utils"], function (require, exports, Backbone_1, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WebsiteModel = void 0;
    var WebsiteModel = /** @class */ (function (_super) {
        __extends(WebsiteModel, _super);
        function WebsiteModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.urlRoot = Utils_1.Utils.getAbsoluteUrl(getExtensionAssetsPath('services/DropShipItemsBehavior.Service.ss'));
            return _this;
        }
        return WebsiteModel;
    }(Backbone_1.Model));
    exports.WebsiteModel = WebsiteModel;
});
